export default class ClientErrorBoundary {
    provides() {
        return {
            'root-wrappers': [() => require('./withErrorBoundary').default],
        };
    }
}
